export const operations = {
label: 'OPERATIONS',
title: 'Disciplined Execution Across Active Markets.',
subtitle: 'One More Global Inc. coordinates market development, distribution support, strategic partnerships, and internal operations through a focused business structure.',

hq_title: 'Americas Operations',
hq_location: 'Houston, Texas, USA',
hq_desc: 'Our Houston office coordinates distribution logistics, strategic partnerships, market development strategies, and regulatory compliance across the territories we serve.',

capabilities_title: 'Core Operational Areas',
scope_title: 'OPERATIONAL SCOPE',
cap_1: 'Market Development',
cap_1_desc: 'Supporting structured market development according to commercial readiness, operational priorities, and applicable market requirements.',
cap_2: 'Distribution Coordination',
cap_2_desc: 'Coordinating product availability, distribution processes, and operational communication across active markets.',
cap_3: 'Strategic Partnerships',
cap_3_desc: 'Developing business relationships that support market access, operational execution, and long-term growth.',
cap_4: 'Operational Support',
cap_4_desc: 'Maintaining internal coordination and processes that support consistent day-to-day business activity.',
};
